export default __webpack_public_path__ + "static/media/7.b9ac1c0a.webp";